module.exports = __webpack_public_path__ + "img/sable_filtrant.4e44faa3.jpg";